module.exports = __webpack_public_path__ + "static/img/logo.9dde44a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 1